export const REGEX_PATTERNS = {
    NAME: /^[A-Za-z]+$/, // Only letters
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Basic email format
    CONTACT: /^\d{10}$/, // Exactly 10 digits
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, // Strong password
};
